export const env: { [s: string]: string | null } = {
  npm_package_version: '0.0.1'
};
